import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './shared/auth.service'
import { UserFeedbackService } from './shared/user-feedback.service'
import { UserService } from './shared/user.service'
import { SettingsService } from './shared/settings.service'
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { PoiService } from './shared/poi.service';
import { PersonService } from './shared/person.service';
import { HuntingDistrictService } from './shared/hunting-district.service';
import { EventsService } from './shared/events.service';
import { skipWhile } from 'rxjs/operators';
import { ContextMembership } from 'diwimamodelweb/lib';
import { GamerecordService } from './shared/gamerecord.service';
import { LabSampleService } from './shared/lab-sample.service';
import { TrophyService } from './shared/trophy.service';
import { EventInviteSharedService } from './cockpit/event-invitation/event-invite-shared.service';
import { GamerecordStatisticsService } from './cockpit/statistics/gamerecord-statistics.service';
import { DialogContentData } from './shared/generic-dialog/generic-dialog.component';
import { SignatureContentData } from './shared/signature-pad-dialog/signature-pad-dialog.component';
import { Observable, of } from 'rxjs';
import * as mapboxgl from 'mapbox-gl';
import { LifeSignService } from './shared/life-sign.service';
import { IconPickerData } from './shared/icon-picker/icon-picker.component';
import { build, version } from 'src/buildVersion';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = `diwima® RC-Web${environment.appPostFix}`
  loggedIn = false
  showLoading = false
  dialogRef: MatDialogRef<any, any>|undefined = undefined

  showContextSelect = true
  selectedContext$: Observable<any>

  // map: mapboxgl.Map

  constructor(
    public translate: TranslateService,
    private authService: AuthService,
    private userService: UserService, 
    private _snackBar: MatSnackBar,
    private userFeedback: UserFeedbackService,
    private settingsService: SettingsService,
    private huntingDistrictService: HuntingDistrictService,
    private dialog: MatDialog,
    private router: Router,
    private gamerecordService: GamerecordService,
    private eventsService: EventsService,
    private labSampleService: LabSampleService,
    private poiService: PoiService,
    private personService: PersonService,
    private trophyService: TrophyService,
    private eventInviteService: EventInviteSharedService,
    private gamerecordStatisticsService: GamerecordStatisticsService,
    private lifeSignService: LifeSignService

  ) {
    Object.getOwnPropertyDescriptor(mapboxgl, "accessToken").set(environment.mapBoxToken)
    this.translate.addLangs(['en', 'de']);
    const browserLang = this.translate.getBrowserLang();
    this.translate.use(browserLang.match(/en|de/) ? browserLang : 'en');
  }

  async ngOnInit() {
    this.userFeedback.showSnackBar.subscribe((message) => { this.openSnackBar(message) })
    this.userFeedback.loading.subscribe((bool) => {
      setTimeout(() => {
        this.showLoading = bool
      })
    })
    this.userFeedback.showDialog.subscribe((data: DialogContentData) => {
      if (this.dialogRef) {
        this.dialogRef.close()
        this.dialogRef = undefined
      }
      this.dialogRef = this.dialog.open(data.entryComponent, {
        data
      })
    })

    this.userFeedback.showIconPicker.subscribe((data: IconPickerData) => {
		if (this.dialogRef) {
        this.dialogRef.close()
        this.dialogRef = undefined
      }
      this.dialogRef = this.dialog.open(data.entryComponent, {
        data
      })
    })
	
    this.userFeedback.showSignature.subscribe((data: SignatureContentData) => {
		if (this.dialogRef) {
        this.dialogRef.close()
        this.dialogRef = undefined
      }
      this.dialogRef = this.dialog.open(data.entryComponent, {
        data
      })
    })

    this.settingsService.selectedUserContext$.pipe(
      skipWhile(el => !el),
    ).subscribe(
      async (context: ContextMembership) => {
        this.showContextSelect = true
        if (!context.identifier || context.identifier == "") return
        if (!context.roles.includes("revierLeiter")) {
          // inform user not revierLeiter... 

        }

      }
    )
    this.selectedContext$ = this.settingsService.selectedUserContext$
    // TODO check if needed? otherwise its loading twice the data (combined with role-guard.service.ts)
    await this.settingsService.loadUserContexts()
  }

  get user$() {
    if (this.authService.user$ == null) { return null }
    return this.authService.user$
  }

  get userData$() {
    return this.userService.user$
  }

  get environment() {
    return environment
  }

  get build() {
    return build
  }

  get version() {
    return version
  }
  
  async signOutUser() {
    await this.settingsService.removeSubs()
    await this.gamerecordService.removeSubs()
    await this.eventsService.removeSubs()
    await this.poiService.removeSubs()
    await this.huntingDistrictService.removeSubs()
    await this.labSampleService.removeSubs()
    await this.personService.removeSubs()
    await this.trophyService.removeSubs()
    await this.eventInviteService.removeSubs()
    await this.gamerecordStatisticsService.removeSubs()
    await this.lifeSignService.removeSubs()
    await this.authService.signOut()
    this.router.navigate(['/auth'])
    setTimeout(async () => {
      window.location.reload()
    }, 100)
  }

  deselectContext() {
    this.settingsService.selectedUserContext$.next(undefined)
    this.router.navigate(['/cockpit'])
  }

  openSnackBar(message, action = "OK") {
    if(!message) {
      message = "Error"
    }
    this.userFeedback.loading.emit(false)
    this._snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
    })
  }
}
